(() => {
  const STORAGE_KEY = "sizeType";
  const SIZE_TYPES = {
    EU: "eu",
    UK: "uk",
  };
  let conversionData = null;
  function getConversionData() {
    if (conversionData) return conversionData;
    const json = document.getElementById("size-conversion-data");
    if (!json) {
      conversionData = {};
      return conversionData;
    }
    try {
      conversionData = JSON.parse(json.textContent);
    } catch (error) {
      console.error("Invalid size conversion data.", error);
      conversionData = {};
    }
    return conversionData;
  }
  // Standard-Einheit kommt aus dem Theme-Setting (settings.default_size_unit),
  // ausgeliefert als data-Attribut am #size-conversion-data-Element. So steuert EIN
  // Setting Server-Label, aktiven Tab und diesen JS-Default konsistent -> kein Flash.
  // sessionStorage (aktive Wahl des Kunden) hat weiter Vorrang.
  const lbrgtDefaultType = (document.getElementById("size-conversion-data")?.dataset.defaultSizeType) || SIZE_TYPES.EU;
  let activeType = sessionStorage.getItem(STORAGE_KEY) || lbrgtDefaultType;
  function getType() {
    return activeType;
  }
  function setType(type) {
    if (!Object.values(SIZE_TYPES).includes(type)) return;
    activeType = type;
    sessionStorage.setItem(STORAGE_KEY, type);

    document.dispatchEvent(
      new CustomEvent("size-conversion:change", {
        detail: {
          type,
        },
      }),
    );
  }
function convert(euSize) {
    const data = getConversionData();
    return {
      eu: euSize,
      uk: data[euSize]?.uk || euSize,
    };
  }
  document.addEventListener("click", (event) => {
  const tab = event.target.closest(".size-tab");
  if (!tab) return;

  setType(tab.dataset.sizeType);
});
  window.SizeConversion = {
    SIZE_TYPES,
    getType,
    setType,
    convert,
  };
})();
